import { Text } from '@adverity/ds-component/text'
import type { TextProps } from '@adverity/ds-component/text'

import { contentPadding } from './constants/shared-styles'
import { Box } from '../box/box'

type Props = Pick<TextProps, 'children'> & {
    title?: string
}

const stylesContent = {
    padding: contentPadding,
    color: 'textInverted',
    wordWrap: 'break-word',

    '& + &': {
        marginTop: 'x-small',
    },
} as const

export const InfoTipContent = ({ children, title }: Props) => (
    <Box css={stylesContent}>
        {title && (
            <Text weight="bold" className="mb-x-small block" textStyle="title" as="h3">
                {title}
            </Text>
        )}
        <Text textStyle="description" color="inverted">
            {children}
        </Text>
    </Box>
)
